import React, { useEffect, useState } from "react";
import { Box, Paper, Typography, Grid } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import ContactsIcon from "@mui/icons-material/Contacts";
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet'; // Added for wallet
import { collection, getCountFromServer, getDoc, doc, query, where } from "firebase/firestore";
import { db } from "../firebase";

const Dashboard = () => {
  const [statsData, setStatsData] = useState({
    sentWhatsapp: 0,
    failedWhatsapp: 0,
    activeContacts: 0,
    inactiveContacts: 0,
    walletBalance: 0, // Initialized at 0
  });

  const fetchStats = async () => {
    try {
      // 1. Fetch the Starting Limit from the Wallet Collection
      const walletDocRef = doc(db, "wallet", "RyHmP8IsqF3kIZMFPtOK");
      const walletSnap = await getDoc(walletDocRef);
      
      let startingLimit = 0;
      if (walletSnap.exists()) {
        // Ensure it's treated as a number
        startingLimit = Number(walletSnap.data().count) || 0;
      }

      // 2. Fetch Sent Count
      const sentCountQuery = query(collection(db, "whatsapphistory"), where("status", "==", "sent"));
      const sentSnap = await getCountFromServer(sentCountQuery);
      const sentCount = sentSnap.data().count;

      // 3. Fetch other counts
      const failedCountQuery = query(collection(db, "whatsapphistory"), where("status", "==", "failed"));
      const failedSnap = await getCountFromServer(failedCountQuery);

      const activeCountQuery = query(collection(db, "contacts"), where("status", "==", "Active"));
      const activeSnap = await getCountFromServer(activeCountQuery);

      const inactiveCountQuery = query(collection(db, "contacts"), where("status", "==", "Inactive"));
      const inactiveSnap = await getCountFromServer(inactiveCountQuery);

      setStatsData({
        sentWhatsapp: sentCount,
        failedWhatsapp: failedSnap.data().count,
        activeContacts: activeSnap.data().count,
        inactiveContacts: inactiveSnap.data().count,
        walletBalance: startingLimit - sentCount, // Dynamic Calculation
      });
    } catch (err) {
      console.error("Dashboard Error:", err);
    }
  };

  useEffect(() => {
    fetchStats();
  }, []);

  const stats = [
    {
      title: "Sent WhatsApp",
      value: statsData.sentWhatsapp,
      bg: "linear-gradient(135deg, #25D366, #1FAA59)",
      icon: <WhatsAppIcon sx={{ fontSize: 35 }} />,
    },
    {
      title: "Failed WhatsApp",
      value: statsData.failedWhatsapp,
      bg: "linear-gradient(135deg, #e53935, #ef5350)",
      icon: <WhatsAppIcon sx={{ fontSize: 35 }} />,
    },
    {
      title: "Active Contacts",
      value: statsData.activeContacts,
      bg: "linear-gradient(135deg, #1976d2, #42a5f5)",
      icon: <ContactsIcon sx={{ fontSize: 35 }} />,
    },
    {
      title: "Inactive Contacts",
      value: statsData.inactiveContacts,
      bg: "linear-gradient(135deg, #9e9e9e, #bdbdbd)",
      icon: <ContactsIcon sx={{ fontSize: 35 }} />,
    },
    {
      title: "Wallet Balance",
      value: statsData.walletBalance, 
      bg: "linear-gradient(135deg, #FF9800, #F57C00)", 
      icon: <AccountBalanceWalletIcon sx={{ fontSize: 35 }} />, 
    },
  ];

  return (
    <Box>
      <Typography
        variant="h5"
        fontWeight="900"
        mb={3}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          position: "relative",
          paddingLeft: "10px",
          "&::before": {
            content: '""',
            width: "4px",
            height: "100%",
            backgroundColor: "#1976d2",
            position: "absolute",
            left: "0",
            borderRadius: "4px",
          },
        }}
      >
        Dashboard Overview
      </Typography>

      <Grid className="row" spacing={3}>
        {stats.map((item, idx) => (
          <Grid className="col-sm-3 mb-3" item xs={12} sm={6} md={2.4} key={idx}> {/* md={2.4} fits 5 cards in a row */}
            <Paper 
              elevation={6}
              sx={{
                p: 2,
                borderRadius: 2,
                textAlign: "center",
                color: "#fff",
                background: item.bg,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                cursor: "pointer",
                transition: "0.3s",
                "&:hover": {
                  transform: "translateY(-5px)",
                  boxShadow: "0 12px 30px rgba(0,0,0,0.25)",
                },
              }}
            >
              {item.icon}
              <Typography variant="subtitle2" fontWeight="600" sx={{ mt: 1 }}>
                {item.title}
              </Typography>
              <Typography variant="h5" fontWeight="900">
                {item.value.toLocaleString()}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Dashboard;